import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import "./ContactUsDialog.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

function ContactUsDialog({ open, setDialogOpen }) {
  const textfieldStyling = {
    marginTop: "10px",
    "& label.Mui-focused": { color: "#A9A9A9" },
    "& label": { color: "#A9A9A9" },
    "& input, & textarea": { color: "#A9A9A9" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#A9A9A9" },
      "&:hover fieldset": { borderColor: "#A9A9A9" },
      "&.Mui-focused fieldset": { borderColor: "#A9A9A9" },
    },
    "& .MuiFormHelperText-root": { color: "red" },
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    country: "",
    phoneNumber: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: "",
    }));
  };
  const handleDialogClose = () => {
    if (open) {
      setDialogOpen(false);
      setFormData({
        name: "",
        email: "",
        country: "",
        phoneNumber: "",
        message: "",
      });
    }
    setErrors({});
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.country.trim()) newErrors.country = "Country is required";

    if (formData.phoneNumber.trim() !== "") {
      if (!/^\d{10}$/.test(formData.phoneNumber)) {
        newErrors.phoneNumber = "Please enter a valid 10-digit phone number";
      }
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Enter a valid 10-digit number";
    }

    if (!formData.message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitClick = async () => {
    if (!validateForm()) return;
    handleDialogClose();
    console.log("From data", formData);
    try {
      const response = await fetch(
        "https://amalgamatedonation.azurewebsites.net/api/ContactUs",
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (data) {
        toast.success("Your response has been recorded");
        console.log("response - ", data);
      } else {
        console.log("Error while submitting your response");
        toast.error("Unable to record your response");
      }
    } catch (error) {
      console.error("Error fetching form details:", error);
    }
  };

  // console.log("formData", formData);

  return (
    <div>
      <Dialog
        disableScrollLock
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          color: "white",
          "& .MuiDialog-paper": {
            backgroundColor: "rgba(20, 20, 20)",
            color: "white",
          },
        }}
      >
        <div>
          <DialogTitle
            id="alert-dialog-title"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <div className="dialogTitle">
              <span className="cont">CONTACT US</span>
            </div>
          </DialogTitle>
          <DialogContent
            sx={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div className="inputContainer">
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
                sx={textfieldStyling}
              />
            </div>

            <div className="inputContainer">
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                sx={textfieldStyling}
              />
            </div>
            <div className="dialogRow3">
              <div className="inputContainer">
                <TextField
                  label="Country"
                  variant="outlined"
                  fullWidth
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  error={!!errors.country}
                  helperText={errors.country}
                  sx={textfieldStyling}
                />
              </div>
              <div className="inputContainer">
                <TextField
                  label="Phone Number"
                  variant="outlined"
                  fullWidth
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber}
                  sx={textfieldStyling}
                />
              </div>
            </div>
            <div className="messageContainer">
              <TextField
                label="Message"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleChange}
                error={!!errors.message}
                helperText={errors.message}
                sx={textfieldStyling}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} sx={{ color: "white" }}>
              Cancel
            </Button>
            <Button onClick={handleSubmitClick} sx={{ color: "white" }}>
              Submit
            </Button>
          </DialogActions>
        </div>
      </Dialog>
       <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default ContactUsDialog;
